/**
 *
 * SubscriptionPageRouter
 *
 */
import * as React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { TabKeys } from '../Tabs/constants';
import { SubscriptionDetailPage } from 'app/pages/SubscriptionDetailPage/Loadable';
import { SubscriptionPortfoliosPage } from 'app/pages/SubscriptionPortfoliosPage/Loadable';
import { useInitializeTab } from 'app/helpers/InitializeTab';
import { useDispatch } from 'react-redux';
import {
  SubscriptionDetailPageManager,
  useSubscriptionDetailPageSlice,
} from 'app/pages/SubscriptionDetailPage/slice';
import { useInitializeSiteTitleWithSuffix } from 'app/helpers/InitializeSiteTitle';
import { withManagers } from 'utils/withManagers';

export const SubscriptionDetailPageRouter = () => {
  const { id = '', tab } = useParams<{ id: string; tab: string }>();
  const history = useHistory();
  useInitializeTab(id, 'subscription');
  useInitializeSiteTitleWithSuffix('Subscription', id);

  const dispatch = useDispatch();
  const {
    actions: { fetchSubscription, cleanup: cleanupSub },
  } = useSubscriptionDetailPageSlice();
  React.useEffect(() => {
    dispatch(fetchSubscription(id));

    return () => {
      dispatch(cleanupSub());
    };
  }, [id, dispatch, fetchSubscription, cleanupSub]);

  switch (tab) {
    case TabKeys.subscription['subscription-details'].urlByTab:
      return <SubscriptionDetailPage />;
    case TabKeys.subscription.portfolios.urlByTab:
      return <SubscriptionPortfoliosPage />;
    default:
      history.replace('/');
      return null;
  }
};

export default withManagers(SubscriptionDetailPageManager)(
  SubscriptionDetailPageRouter,
);
